import { useFetch } from "@4uhub/lib4uhub";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import CardContainer from "../../../components/CardContainer/CardContainer";
import LoginForm, {
  TLoginFormData,
} from "../../../components/LoginForm/LoginForm";
import { authService } from "../../../services/auth.service";
import { tokenService } from "../../../services/token.service";
import { saveUserName } from "../../../services/user.service";

const LoginPage = () => {
  const navigate = useNavigate();
  const { sendRequest, loading } = useFetch(authService.login);

  const onSubmitHandler = useCallback(
    async (values: TLoginFormData) => {
      const { data } = await sendRequest(values);
      if (data) {
        saveUserName(values.username);
        const redirectUrl = localStorage.getItem("redirect");
        const lastLoggedEstablishment = Number(redirectUrl?.split("/")[2]);
        tokenService.saveTokens(
          data.access_token,
          data.refresh_token,
          lastLoggedEstablishment || data.establishmentTenantSequential
        );
        if (redirectUrl) {
          navigate(redirectUrl);
          localStorage.removeItem("redirect");
          return;
        }

        navigate(`/e/${data.establishmentTenantSequential}`, { replace: true });
      }
    },
    [sendRequest, navigate]
  );

  return (
    <CardContainer>
      <LoginForm onSubmit={onSubmitHandler} loading={loading} />
    </CardContainer>
  );
};

export default LoginPage;
